import React, { Component } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
import { withTheme } from '../../../theme';
import PropTypes from 'prop-types';
import R from '../../../core-res/R';
import DRNText from '../../../standard/Text/DRNText';
import DRNNewIndicator from '../../../standard/NewIndicator';
import { getLabelStyle } from '../util/getStyle';
class TopBar extends Component {
    constructor() {
        super(...arguments);
        this.getContainerStyle = () => {
            const { isActive, theme, activeTabColor } = this.props;
            if (!isActive)
                return;
            return {
                borderBottomWidth: R.border.width.bold,
                borderBottomColor: activeTabColor || theme.brand,
            };
        };
    }
    render() {
        const { label, isActive, theme, activeTabColor, showIndicator, smartKey } = this.props;
        return (<View style={[styles.container, this.getContainerStyle()]}>
        <Animated.View style={styles.textContainer}>
          <DRNText style={[styles.label, getLabelStyle(isActive, theme, activeTabColor)]} smartKey={smartKey}>
            {label}
          </DRNText>
          {showIndicator && <DRNNewIndicator style={{ left: -R.spacing.xxs, top: -R.spacing.xs }}/>}
        </Animated.View>
      </View>);
    }
}
TopBar.propTypes = {
    label: PropTypes.string.isRequired,
    theme: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
    activeTabColor: PropTypes.string,
    showIndicator: PropTypes.bool,
    smartKey: PropTypes.string,
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: R.spacing.xs,
        width: '100%',
        alignItems: 'center',
    },
    textContainer: {
        flexDirection: 'row',
    },
    label: Object.assign({}, R.typography.uiBaseline, { fontWeight: R.typography.weightMedium.fontWeight }),
});
export default withTheme(TopBar);
